import React from "react";
import Box from "components/common/Box";
import Image from "components/common/Image";

const asideImageProps = {
  src: "/images/signup/aside-panel.png",
  alt: "Jarvis signup",
  objectFit: "cover",
};

const SignUpAsidePanel = ({ compact = false }) => {
  if (compact) {
    return (
      <Box
        sx={{
          width: "100%",
          bgcolor: "#fff",
          position: "relative",
          overflow: "hidden",
          lineHeight: 0,
        }}
      >
        <Box
          component="img"
          src="/images/signup/mobile-hero.png"
          alt="Jarvis — Investing powered by AI"
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        bgcolor: "#017cec",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Image
        {...asideImageProps}
        rootStyle={{
          width: "100%",
          height: "100%",
          alignItems: "flex-start",
        }}
        imgStyle={{
          width: "85%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center top",
        }}
      />
    </Box>
  );
};

export default SignUpAsidePanel;
